export const LOGIN = 'Login/LOGIN';
export const LOGIN_GOOGLE_URL = 'Login/LOGIN_GOOGLE';
export const LOGIN_SOCIAL = 'Login/LOGIN_SOCIAL';
export const LOGOUT = 'Login/LOGOUT';
export const LOGIN_ERROR = 'Login/LOGIN_ERROR';